// libs
import $ from "jquery";
import { TweenMax, Power3 } from "gsap";

// local
import * as ua from "../../utils/ua";
import AppBase from "../AppBase";

const SLIDE_MAX = 4;
const SLIDE_INTERVAL = 5500;
const SLIDE_SWAP_DURATION = 1;

export default class SlideApp extends AppBase {
  constructor() {
    super();

    this.images = [];
    this.loadedFlags = {};
    this.index = 0;
    this.$current = null;

    if (ua.isPC()) {
      SlideApp.urls = [
        "/assets/img/pc/food1.jpg",
        "/assets/img/pc/view1.jpg",
        "/assets/img/pc/food2.jpg",
        "/assets/img/pc/store6.jpg"
      ];
    } else {
      SlideApp.urls = [
        "/assets/img/sp/food1.jpg",
        "/assets/img/sp/view1.jpg",
        "/assets/img/sp/food2.jpg",
        "/assets/img/sp/store6.jpg"
      ];
    }
  }

  init() {
    const url = SlideApp.urls[0];
    const image = new Image();
    const self = this;

    image.onload = function() {
      // console.log(this.src);
      self.images.push(this.src);
      self.loadedFlags[url] = true;
      self.dispatcher.trigger("init");
    };
    image.src = url;
  }

  start() {
    const id = "js-slideItem" + 0;
    const $el = $("<div class='item' id='" + id + "'>");

    $el.css({"background-image": "url(" + this.images[0] + ")"});
    $("#js-slide").append($el);
    this.$current = $el;

    TweenMax.fromTo("#" + id, 2,
      {scale: 1.1},
      {scale: 1, ease: Power3.easeOut},
    );

    setTimeout(()=> {
      this.next();
    }, SLIDE_INTERVAL + 2000);
  }

  next() {
    this.index++;

    if (this.index >= SLIDE_MAX) {
      this.index = 0;
    }

    const url = SlideApp.urls[this.index];

    const loaded = this.loadedFlags[url];
    // console.log("[next]", "index:", this.index, "loaded:", loaded);

    if (loaded) {
      this.swapTransition();
    } else {
      const image = new Image();
      const self = this;

      image.src = url;
      image.onload = function() {
        self.images.push(this.src);
        self.loadedFlags[url] = true;
        self.swapTransition();
      };
    }
  }

  swapTransition() {
    const currentId = this.$current.attr("id");
    const nextId = "js-slideItem" + this.index;
    let $el = $(`<div class="item" id="${nextId}">`);

    if (this.index === 3) {
      $el = $(`<div class="item withCover" id="${nextId}">`);
    }

    $el.css({
      // "transform": "translateX(100px)",
      // "width": "100%",
      "background-image": "url(" + this.images[this.index] + ")"
    });

    $("#js-slide").prepend($el);

    TweenMax.fromTo("#" + nextId, SLIDE_SWAP_DURATION,
      {x: 300},
      {x: 0, ease: Power3.easeOut},
    );

    TweenMax.to("#" + currentId, SLIDE_SWAP_DURATION, {
      x: 0,
      width: "0%",
      ease: Power3.easeOut,
      onComplete: () => {
        this.$current.remove();
        this.$current = $el;

        setTimeout(()=> {
          this.next();
        }, SLIDE_INTERVAL);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/js/apps/modules/SlideApp.js